import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';

export default class TermsAndConditions extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Unauthenticated>
                <div className="text-white">
                    <h1 className="text-xl font-bold mb-4">
                        Terms & Conditions
                    </h1>

                    <p className="mb-2">
                        1). One entry per person. This includes whether you attended an in person event or played online.
                    </p>

                    <p className="mb-2">
                        1. The Prize Draw is open to employees of BT Group’s Consumer unit, Consumer Legal and Consumer 
                        Corporate Affairs and Consumer Digital and CIO employees and our third party partners and franchisees, 
                        resident in the UK and aged 18 years or over.  Only one entry per person.
                    </p>

                    <p className="mb-2">
                        2. The prizes are 1 x Bose speaker, 5 Mophie Powerstations, 10 x Anton Pro ANC headphones, 
                        25 x wireless, glass topped chargers, adaptable with any device that supports QI Technology. 
                        Only 1 prize will be allocated for each winner.
                    </p>

                    <p className="mb-2">
                        3. To enter you must play the Cyber Security game between 12 December 2022 and 2 January 2023.
                    </p>

                    <p className="mb-2">
                        4. The winners will be the first 41 entries drawn at random by the Internal Communications 
                        team on 4 January 2023. Winners will be notified by email on or before 12th January 2023 
                        and prizes will be delivered by the end of March 2023.
                    </p>

                    <p className="mb-2">
                        5. The prize winners (name and work location only) will be shared in the comments section of 
                        the competition post on Workplace. 
                    </p>

                    <p className="mb-2">
                        6. The Promoter reserves the right to verify the eligibility of entrants and check their identity. 
                    </p>

                    <p className="mb-2">
                        7. The prize is subject to availability.
                    </p>

                    <p className="mb-2">
                        8. The Promoter reserves the right to substitute a prize of equivalent or greater value if 
                        this is necessary for reasons beyond its control. 
                    </p>

                    <p className="mb-2">
                        9. Your personal details will be retained for the purpose of the Prize Draw and will not be 
                        processed for any other purpose, unless you choose or have chosen to receive information from the Promoter. 
                        For more information please see BT Group’s Privacy Policy which can be found at{" "}
                        <a
                            href="https://www.bt.com/privacy-policy/"
                            target="_blank"
                            className="underline"
                        >
                            https://www.bt.com/privacy-policy/
                        </a>. 
                    </p>

                    <p className="mb-2">
                        10. No cash alternative will be offered and prizes are non-transferable. 
                    </p>

                    <p className="mb-2">
                        11. The Promoter reserves the right to re-draw the winner if they cannot be 
                        contacted within a reasonable period of time (to be established at the promoter’s sole discretion) 
                        and the right to disqualify any entrant or select alternative winner in the event that it believes 
                        that any entrant hasn’t followed these Terms and Conditions. 
                    </p>

                    <p className="mb-2">
                        12. Submitting an entry to this Prize Draw is deemed to be acceptance by the entrants of 
                        these Terms and Conditions. 
                        The Promoter reserves the right to alter, amend or foreclose this Prize Draw without 
                        prior notice in the event that unforeseen circumstances make this unavoidable. 
                    </p>

                    <p className="mb-2">
                        13. The Promoter accepts no responsibility for any loss, damage, injury or disappointment 
                        suffered by any entrant resulting from entering this Prize Draw or by the entrant’s 
                        acceptance of the prize[, or any damage to any entrant’s or other person’s computer 
                        or mobile phone equipment as a consequence of downloading any material relating to this promotion. 
                    </p>

                    <p className="mb-2">
                        14. This promotion is governed by the laws of England and Wales. 
                    </p>

                    <p className="mb-2">
                        15. The Promoter is EE Ltd, 1 Braham Street, London, E1 8EE.
                    </p>

                    <h2 className="text-xl font-bold mt-8 mb-4">
                        Privacy Notice
                    </h2>

                    <p className="mb-2">
                        You are registering to take part in the EE Cyber Security Activation.
                    </p>

                    <p className="mb-2">
                        To manage the competition, we need to collect the following information from you: 
                        your name, email address, and your score. If you’re one of our winners, we may ask 
                        you to provide a delivery address to enable your prize to be delivered to a destination 
                        of your choice, this may be shared with a third party delivery company outside BT Group.
                    </p>

                    <p className="mb-2">
                        Your information will be processed by EE & Gen Digital. The information we collect 
                        from you will be handled securely, in confidence, and will be securely destroyed 2 weeks 
                        after the competition has closed (competition close date: 14th December) within Gen Digital’s 
                        data and 3 months after the competition has closed within EE’s data. 
                        The names of the winners will be posted on Workplace along with details of the prize they have won.
                    </p>

                    <p className="mb-2">
                        We are collecting this information on a voluntary basis. We will process your information 
                        on the grounds of consent. You have certain rights regarding your information. 
                        For more information on your rights and how we process your information generally 
                        please refer to the employee Privacy Policy | BT. 
                        If you have any questions, or wish to withdraw your consent, please contact{" "}
                        <a
                            href="mailto:Consumer.Communications@ee.co.uk"
                            className="underline"
                        >
                            Consumer.Communications@ee.co.uk
                        </a>
                    </p>

                    <p className="mb-2">
                        The information requested on this form will be used for competition administration only. 
                        Winners will be contacted separately and asked to provide further details, 
                        including a delivery address for their prize. 
                        Personal details for all entries outside this will be destroyed by 6pm on 19 December. 
                        Winners’ personal details will be kept for 14 days in Gen Digital’s database and 90 days, 
                        within BT’s database from the date the competition closes then destroyed. 
                    </p>

                    <p className="mb-2">
                        Please see BT Group's employee privacy notice for more information -{" "}
                        <a
                            href="https://www.bt.com/bt-plc/assets/documents/career/bt-employee-privacy-notice.pdf"
                            target="_blank"
                            className="underline"
                        >
                            https://www.bt.com/bt-plc/assets/documents/career/bt-employee-privacy-notice.pdf
                        </a>
                    </p>
                </div>
            </Unauthenticated>
        );
    }
}
